import { StandardValidationConstraintKeys } from './standard-validation-constraint-keys'

export const STANDARD_VALIDATION_MESSAGE_KEYS: { [key in StandardValidationConstraintKeys]: string } = {
    MIN: 'STO.VALIDATION.DEFAULTS.MIN',
    MAX: 'STO.VALIDATION.DEFAULTS.MAX',
    MIN_LENGTH: 'STO.VALIDATION.DEFAULTS.MIN_LENGTH',
    MAX_LENGTH: 'STO.VALIDATION.DEFAULTS.MAX_LENGTH',
    REQUIRED: 'STO.VALIDATION.DEFAULTS.REQUIRED',
    PATTERN: 'STO.VALIDATION.DEFAULTS.PATTERN',
    VALID_NUMBER: 'STO.VALIDATION.DEFAULTS.VALID_NUMBER',
}
